<script>
	import {onMount} from 'svelte'
	import {getToken, getUrl, getPid} from './csql.js'
	import Catalogo from './Catalogo.svelte'
	import Usuarios from './usuarios/Usuarios.svelte'
	import Login from './usuarios/login.svelte'
	import Logout from './usuarios/logout.svelte'
	import Registro from './usuarios/registro.svelte'
	import FAQ from './faq.svelte'
	// import Header from './Header.svelte'
	// import Filtro from './Filtro.svelte'
	// import Profile from './usuarios/Profile.svelte'
	// import Invoice from './cart/Invoice.svelte'
	import Menu from './Menu.svelte'
	import Buscar from './eventos/buscar.svelte'
	import Ordenar from './eventos/ordenar.svelte'
	// import Compras from './compras/compras.svelte'
	import GestorCompras from './compras/GestorCompras.svelte'
	import {usuario,filtro_cate,orden_por, orden_dir,filtro_buscar,filtro_size, filtro_page} from './store.js'


	//let path = window.location.search
	//  618  kzqkG
	const params = new URL(location.href).searchParams;
	const pid = params.get('pid') || 0;


	// if(parseInt(pid)>0 ) console.log(getUrl(pid))
	// else console.log(getPid(pid))

	let producto = 0

	let loading = false

	let view = 'menu'

	let tokenReady = false

	onMount( async() => {
		loading = true
		const data = await getToken()
		loading= false

		localStorage.setItem('UPM_AUTH',JSON.stringify({usr:'upm',token:data.token}))

		let USR = JSON.parse(localStorage.getItem('UPM_USER')) || false

		if(USR.user && USR.user.email){
			usuario.set(USR.user)
		}

		tokenReady = true
	})

	let email_a_registrar = ''

	function handler(params){
		if (params.view_dst==='registro') { email_a_registrar = params.email}
		view = params.view_dst || 'catalogo'
	}


	function handler2(args){
		view = args.goto || 'catalogo'
	}

	function alMenu(){
		filtro_cate.set('TODOS')
		filtro_size.set("''")
		orden_por.set('touched')
		orden_dir.set('desc')
		filtro_buscar.set('')
		filtro_page.set(0)
		view='menu'
	}


	function back(event) {
		// console.log("222")
  //        event.stopPropagation()
  //        event.preventDefault()
		// window.history.forward()
  //        return event.returnValue = '';
	}

	// 622 kzqkq
	if(!parseInt(pid) && pid.length>2){
		producto = getPid(pid)
		view='catalogo'
		// console.log(getPid(pid))
	}


</script>
<!-- <svelte:window on:beforeunload={back}/> -->
{#if tokenReady}

	<header class="sticky" style="height: auto;">

		<div class="row" style="background-color: #0E0E0E;display:flex; align-items:center;padding:1px 4px;">
			<!-- <div class="col-sm-1">
		  		<img src="images/heart3.png" alt="" width="35px" style="padding:0px 7px">
			</div> -->
			<div class="col-sm-8">
			  		<!-- <small  xstyle="font-family: Sacramento;color:white;font-weight: bold;margin-top:8px;padding-left:12px;">
			  		</small> -->
			  	<span style="color:white;margin-top:8px;padding-left:12px;margin:4px 0px;" class="v-center">
			  		<h2 style="font-family: Sacramento;font-weight: bold;padding-left:10px;">Un Poco M&aacute;s</h2>
			  		<img src="images/heart3.png" alt="" width="30px" style="margin-top:-8px">
			  	</span>
			</div>
			<div class="col-sm-3">
				<a href="https://www.facebook.com/unpocomasindumentaria/" title="Facebook">
					<img src="https://icongr.am/fontawesome/facebook.svg?size=20&color=ffffff" alt="">
				</a>
				<a href="https://www.instagram.com/un_poco_mas_outlet/" title="Instagram">
					<img src="https://icongr.am/fontawesome/instagram.svg?size=20&color=ffffff" alt="">
				</a>
				<a href="https://wa.me/5491130503438?text=(UP+)%20Hola%20tengo%20una%20consulta" title="WhatsApp">
					<img src="https://icongr.am/fontawesome/whatsapp.svg?size=20&color=ffffff" alt="">
				</a>
			</div>
			<div class="col-sm-1" style="text-align: center;">
				<img src="images/cart.jpg" alt="" width="24px" style="padding:0px 0px;border-radius:5px;" on:click={()=>view='cart'}>
			</div>
		</div>

		<div class="row" style="font-size: 1.3em;padding:4px 4px;">
			<div class="col-sm-6">
					<span class="hovered" on:click="{alMenu}" style="font-weight:bolder;" >&#9776;&nbsp;MENU&nbsp;&nbsp;&nbsp;&nbsp;</span>
					<span class="hovered" on:click="{()=>view='buscar'}">Buscar/Filtrar &#128269;</span>
			</div>
			<div class="col-sm-6 " style="text-align: right;">
				{#if view==='catalogo'}
					<span class="hovered" on:click="{()=>view='ordenar'}"><strong style="color:#226699;">&#8645;</strong> Ordenar</span>
				{/if}

				{#if $usuario.email?.trim() && $usuario.email?.trim().substr(0,8)!=="__fake__"}
					<span class="hovered" style="margin-left:20px;" on:click={()=>view='logout'}>{$usuario.email}</span>
				{:else}
					<span class="hovered" style="margin-left:20px;" on:click={()=>view='login'}>&#128274; MAYORISTAS</span>
				{/if}


			</div>
		</div>


	</header>



	<!-- Buscar -->
	{#if view==='buscar'}
		<Buscar {handler} />
	{/if}

	<!-- Ordenar -->
	{#if view==='ordenar'}
		<!-- <Ordenar  orderBy={$orden_por} orderDir={$orden_dir} handler={ordenar_handler}/> -->
		<Ordenar {handler} />
	{/if}

	{#if view==='login'}
		<Login {handler}/>
	{/if}

	{#if view==='logout'}
		<Logout {handler}/>
	{/if}

	{#if view==='registro'}
		<Registro {handler} email={email_a_registrar }/>
	{/if}

	{#if view==='faq'}
		<FAQ />
	{/if}

	<div style="margin-top:0px;">

		{#if view==='menu'}
			<Menu {handler} />
		{/if}

		{#if view==='catalogo'}
			<Catalogo bind:producto={producto}/>
		{/if}

		{#if view==='cart'}
			<!-- <Compras close={handler} evento="listar"/> -->
			<GestorCompras {handler2}>
				<span slot="salir"><button on:click={()=>view='catalogo'}>Volver al Catalogo</button></span>
			</GestorCompras>

		{/if}

	</div>


{/if}
